import { Component, OnInit } from '@angular/core';
import { QuestionType } from 'src/app/models/survey/questionType';
import { QuestionTypeService } from 'src/app/services/survey/question-type.service';
import { Message } from 'src/app/models/message';

@Component({
  selector: 'app-question-type-list',
  templateUrl: './question-type-list.component.html',
  styleUrls: ['./question-type-list.component.scss']
})
export class QuestionTypeListComponent implements OnInit {

  qtypes: QuestionType;
  msg: Message;

  constructor( private qtypeService: QuestionTypeService ) { }

  ngOnInit() {
    this.getAllAdm();
  }  
  
  getAllAdm(){
    this.qtypeService.getAllAdm().subscribe(
      res => { this.qtypes = res['data']; },
      err => { this.msg = err; }
    );
  }


}
